"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var forms_1 = require("@angular/forms");
var ngx_bootstrap_1 = require("ngx-bootstrap");
var typeahead_1 = require("@bhtp-client-api/typeahead");
var _1 = require("./");
exports.DECLARED_AND_EXPORTED_COMPONENTS = [
    _1.BhtpTypeaheadDirective,
    _1.TypeaheadAirlineComponent,
    _1.TypeaheadCarRentalComponent,
    _1.TypeaheadCountryComponent,
    _1.TypeaheadCruiseComponent,
    _1.TypeaheadHotelComponent,
    _1.TypeaheadRentalCompanyComponent,
    _1.TypeaheadTourComponent,
    _1.TypeaheadStateComponent
];
var BhtpTypeaheadModule = BhtpTypeaheadModule_1 = (function () {
    function BhtpTypeaheadModule() {
    }
    BhtpTypeaheadModule.forRoot = function () {
        return {
            ngModule: BhtpTypeaheadModule_1,
            providers: [ngx_bootstrap_1.ComponentLoaderFactory, ngx_bootstrap_1.PositioningService]
        };
    };
    return BhtpTypeaheadModule;
}());
BhtpTypeaheadModule = BhtpTypeaheadModule_1 = __decorate([
    core_1.NgModule({
        imports: [
            common_1.CommonModule,
            forms_1.FormsModule,
            forms_1.ReactiveFormsModule,
            typeahead_1.BhtpTypeaheadServiceModule,
            ngx_bootstrap_1.TypeaheadModule
        ],
        declarations: [
            exports.DECLARED_AND_EXPORTED_COMPONENTS
        ],
        exports: [
            exports.DECLARED_AND_EXPORTED_COMPONENTS
        ],
        providers: [
            ngx_bootstrap_1.ComponentLoaderFactory,
            ngx_bootstrap_1.PositioningService
        ]
    })
], BhtpTypeaheadModule);
exports.BhtpTypeaheadModule = BhtpTypeaheadModule;
var BhtpTypeaheadModule_1;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/type-ahead/type-ahead.module.js